export const GET_REFERENCE_DATA = 'GET_REFERENCE_DATA';
export const getReferenceData = () => ({
  type: GET_REFERENCE_DATA,
});

export const GET_REFERENCE_DATA_SUCCESS = 'GET_REFERENCE_DATA_SUCCESS';
export const getReferenceDataSuccess = (data) => ({
  type: GET_REFERENCE_DATA_SUCCESS,
  data,
});

export const GET_REFERENCE_DATA_FAILURE = 'GET_REFERENCE_DATA_FAILURE';
export const getReferenceDataFailure = (error) => ({
  type: GET_REFERENCE_DATA_FAILURE,
  error,
});
